/* Svensk katalog for locale-payroll-employees-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'pay.personalia': 'Personuppgifter',
  'pay.personalInfo': 'Personuppgifter',
  'pay.edit': 'Redigera',
  'pay.documents': 'Dokument',
  'pay.description': 'Beskrivning',
  'pay.contract': 'Anställningsavtal',
  'pay.open': 'Öppna',
  'pay.download': 'Ladda ner',
  'pay.delete': 'Ta bort',
  'pay.employment': 'Anställning',
  'pay.positionAndAgreement': 'Befattning och avtal',
  'pay.searchOccupationCodes': 'Sök i yrkeskoder ...',
  'pay.cancel': 'Avbryt',
  'pay.saveEmployment': 'Spara anställning',
  'pay.employmentFrom': 'Anställningen gäller från',
  'pay.employmentFromHint': 'Datumet då den anställda hade, eller ska ha, sin första arbetsdag i ditt företag. Detta datum är oberoende av när du började bokföra i Plumme.',
  'pay.endDate': 'Slutdatum',
  'pay.endDateHint': 'Lämna fältet tomt när anställningen fortfarande pågår.',
  'pay.occupationCode': 'Yrkeskod',
  'pay.occupationCodeHint': 'Sök i det offentliga registret över yrkeskoder och välj den som passar bäst. Fältet används för statistik över yrken i Norge.',
  'pay.employmentType': 'Anställningstyp',
  'pay.employmentForm': 'Anställningsform',
  'pay.workingHoursScheme': 'Arbetstidsordning',
  'pay.workingHoursSchemeHint': 'De flesta anställda har Ej skiftarbete, men vissa hamnar även under de andra kategorierna.',
  'pay.hoursFullWeek': 'Timmar för hel vecka',
  'pay.salaryType': 'Lönetyp',
  'pay.hourlyPay': 'Timlön',
  'pay.fixedPay': 'Fast lön',
  'pay.ftePercent': 'Tjänstgöringsgrad',
  'pay.ftePercentHint': 'Välj en uppskattad tjänstgöringsgrad. Om du är osäker, ange närmaste procent.',
  'pay.fullTime': 'Heltid',
  'pay.partTime': 'Deltid',
  'pay.employmentScope': 'Anställningens omfattning',
  'pay.adjustHoursBy': 'Justera timmar efter',
  'pay.perWeek': 'Per vecka',
  'pay.perMonth': 'Per månad',
  'pay.hoursPerWeek': 'Timmar per vecka',
  'pay.hoursPerMonth': 'Timmar per månad',
  'pay.otherEntityNumber': 'Annat verksamhetsnummer',
  'pay.optionalEntityNumber': 'Valfritt verksamhetsnummer',
  'pay.priorPayOutsidePlumme': 'Tidigare lön utanför Plumme utbetald från ditt företag',
  'pay.priorPayHelp': 'Fyll bara i lön som inte är registrerad i Plumme men som har betalats ut av företaget.',
  'pay.warning': 'Varning:',
  'pay.forPublicStatistics': 'För offentlig statistik - fylls bara i om relevant',
  'pay.lastAdjustmentDate': 'Datum för senaste lönejustering',
  'pay.salaryGrade': 'Lönesteg',
  'pay.salaryGradePh': 'T.ex. 45',
  'pay.agreedSalary': 'Avtalad lön',
  'pay.save': 'Spara',
  'pay.annualSalary': 'Årslön',
  'pay.agreementTaxHeading': 'Avtal, semesterersättning, skatt och arbetsgivaravgift',
  'pay.tax': 'Skatt',
  'pay.notFetchedFromAltinn': 'Inte hämtat från Altinn',
  'pay.salaryPerYear': 'Lön per år',
  'pay.holidayPay': 'Semesterersättning',
  'pay.employerContribution': 'Arbetsgivaravgift',
  'pay.estimatedTax': 'Uppskattad skatt',
  'pay.estimatedAnnualCost': 'Uppskattad årskostnad',
  'pay.noAgreedSalary': 'Ingen avtalad lön har lagts in',
  'pay.taxCard': 'Skattekort',
  'pay.taxCardHelp': 'Skattekort hämtas inte ännu. Detta kopplas när integrationen mot Skatteetaten är klar.',
  'pay.fixedLines': 'Fasta rader',
  'pay.fixedLinesHelp': 'Lönerader som vanligtvis ingår i varje löneutbetalning.',
  'pay.newFixedLine': 'Skapa ny fast rad',
  'pay.seeFixedLines': 'Visa fasta lönerader',
  'pay.payslips': 'Lönebesked',
  'pay.noPayslips': 'Inga lönebesked har skapats ännu.',
  'pay.gross': 'Brutto',
  'pay.paidOut': 'Utbetalt',
  'pay.employeePortal': 'Personalportal',
  'pay.employeePortalSub': 'Lönebesked, resor och utlägg för den anställda.',
  'pay.needEmailFirst': 'Ange en giltig e-postadress på den anställdas profil innan du ger åtkomst.',
  'pay.goToTravelExpenses': 'Gå till resor och utlägg',
  'pay.saveEmployee': 'Spara anställd',
  'pay.nationalId': 'Personnummer',
  'pay.hasInternationalId': 'Har internationellt ID',
  'pay.name': 'Namn',
  'pay.phone': 'Telefonnummer',
  'pay.email': 'E-post',
  'pay.address': 'Adress',
  'pay.country': 'Land',
  'pay.address1': 'Adress 1',
  'pay.streetAddress': 'Gatuadress',
  'pay.address2': 'Adress 2',
  'pay.optional': 'Valfritt',
  'pay.postalCode': 'Postnummer',
  'pay.postalPlace': 'Postort',
  'pay.postalPlacePh': 'Postort ...',
  'pay.accountNumber': 'Kontonummer',
  'pay.hasForeignAccount': 'Har utländskt kontonummer',
  'pay.mainOrSecondaryEmployer': 'Bi-/huvudarbetsgivare',
  'pay.taxAndDutyRules': 'Skatte- och avgiftsregler',
  'pay.noteOptional': 'Anteckning (valfritt)',
  'pay.notePh': 'Skriv en anteckning ...',
  'pay.employees': 'Anställda',
  'pay.employeesHelp': 'Registret över alla anställda i företaget. Tryck på en anställd för att se personuppgifter, anställning, lön och lönebesked.',
  'pay.allEmployees': 'Alla anställda i ditt företag',
  'pay.newEmployee': 'Ny anställd',
  'pay.newEmployeeHelp': 'Registrera en ny anställd med personuppgifter, anställning och lönevillkor. Den anställda tas då med i lönekörningar och a-meldingen.',
  'pay.noEmployees': 'Inga anställda ännu',
  'pay.salaryTypeLabel': 'Lönetyp:',
  'pay.status': 'Status',
  'pay.statusHelp': 'Aktiv anställning betyder att den anställda tas med i lönekörningar. Avslutad betyder att anställningen har upphört.',
  'pay.payroll': 'Lön',
  'pay.payrollSub': 'Kör lön, följ upp anställda, terminer och semesterersättning.',
  'pay.payrollModuleHelp': 'Lönemodulen samlar allt om anställda och lön: lönekörning, arbetsgivaravgift och skatteavdrag, pension (OTP), semesterersättning, resor och utlägg samt inställningar. Växla mellan undersidorna i rullgardinsmenyn.',
  'pay.payrollPages': 'Lönesidor',
  'pay.payrollPagesHelp': 'Växla mellan undersidorna i lön — Anställda, Löneutbetalning, Arbetsgivaravgift och skatt, Pension/OTP, Fasta lönerader, Resor och utlägg, Löneöversikt, Semesterersättningslista, Löneinställningar och Lönetyper.',
  'pay.employmentStatus': 'Anställning',
  'pay.employmentStatusHelp': 'Visar om anställningen är aktiv eller avslutad. Aktiva anställda tas med i lönekörningar och rapporteras i a-meldingen.',
  'pay.backToPayrollRun': 'Tillbaka till löneutbetalning',
  'pay.showAllEmployees': 'Visa alla anställda',
  'pay.yourEmployers': 'Dina arbetsgivare',
  'pay.yourClients': 'Dina klienter',
  'pay.bgForEmployer': 'Bakgrundsfärg för denna arbetsgivare',
  'pay.bgColour': 'Bakgrundsfärg',
  'pay.receiptHelp': 'Ta en bild, ladda upp, dra in eller klistra in. Utlägg utan verifikation kan inte skickas in.',
  'pay.takePhoto': 'Ta bild',
  'pay.uploadFile': 'Ladda upp bild/fil',
  'pay.remove': 'Ta bort',
  'pay.registerExpense': 'Registrera utlägg',
  'pay.receiptRequired': 'Verifikation krävs',
  'pay.category': 'Kategori',
  'pay.pickCategory': 'Välj kategori',
  'pay.date': 'Datum',
  'pay.paidWith': 'Betalt med',
  'pay.privateExpense': 'Privat utlägg',
  'pay.companyCard': 'Företagskort/företagskonto',
  'pay.amount': 'Belopp',
  'pay.currency': 'Valuta',
  'pay.whatIsExpenseFor': 'Vad gäller utlägget?',
  'pay.registerTravel': 'Registrera resa',
  'pay.sentForApproval': 'Skickas för godkännande',
  'pay.dateFrom': 'Datum från',
  'pay.dateTo': 'Datum till',
  'pay.travelType': 'Resetyp',
  'pay.travelWithExpenses': 'Resa med utlägg/körning',
  'pay.drivingOnly': 'Endast körning',
  'pay.travelWithSubsistence': 'Resa med traktamente',
  'pay.destination': 'Resmål',
  'pay.destinationPh': 'Stad, kund eller plats',
  'pay.from': 'Från',
  'pay.startPlace': 'Startplats',
  'pay.to': 'Till',
  'pay.endPlace': 'Destination',
  'pay.kilometres': 'Kilometer',
  'pay.purpose': 'Syfte',
  'pay.purposeHelp': 'Vad var syftet med resan?',
  'pay.note': 'Anteckning',
  'pay.createTravelClaim': 'Skapa reseräkning',
  'pay.purposePh': 'T.ex. kundmöte i Drammen',
  'pay.whereDidYouGo': 'Vart gick resan?',
  'pay.norway': 'Norge',
  'pay.tolls': 'Vägtullar',
  'pay.tollsPaidWith': 'Vägtull betald med',
  'pay.fromDate': 'Från datum',
  'pay.toDate': 'Till datum',
  'pay.type': 'Typ',
  'pay.hotel': 'Hotell',
  'pay.otherAccommodation': 'Annat boende',
  'pay.guesthouse': 'Pensionat eller barack',
  'pay.place': 'Plats',
  'pay.hotelOrPlace': 'Hotell eller plats',
  'pay.travelClaim': 'Reseräkning',
  'pay.rejectedByEmployer': 'Avvisad av arbetsgivaren',
  'pay.newAccommodation': 'Nytt boende',
  'pay.newTrip': 'Ny körning',
  'pay.newExpense': 'Nytt utlägg',
  'pay.noLinesYet': 'Inga rader ännu',
  'pay.employee': 'Anställd',
  'pay.subsistence': 'Traktamente',
  'pay.payslip': 'Lönebesked',
  'pay.close': 'Stäng',
  'pay.netPaid': 'Netto utbetalt',
  'pay.period': 'Period',
  'pay.payAndDeductions': 'Lön och avdrag',
  'pay.grossPay': 'Bruttolön',
  'pay.withholdingTax': 'Skatteavdrag',
  'pay.expenseRefund': 'Ersättning utlägg/resa',
  'pay.payslipPdfNote': 'PDF-visning och utskick kopplas när lönebeskedsgeneratorn görs tillgänglig i Plumme.',
  'pay.noPayslipsYet': 'Inga lönebesked ännu.',
  'pay.myExpenses': 'Mina utlägg',
  'pay.noExpensesInView': 'Inga utlägg i den här vyn.',
  'pay.expenses': 'Utlägg',
  'pay.preview': 'Förhandsgranska',
  'pay.loadingReceipt': 'Läser in verifikation...',
  'pay.canStillDownload': 'Verifikationen kan fortfarande laddas ner manuellt.',
  'pay.cannotPreview': 'Den här filtypen kan inte förhandsgranskas här.',
  'pay.openNewTab': 'Öppna i ny flik',
  'pay.myTravel': 'Mina resor',
  'pay.noTravelInView': 'Inga resor i den här vyn.',
  'pay.fetchingPortal': 'Hämtar personalportalen',
  'pay.portalFailed': 'Kunde inte hämta personalportalen',
  'pay.back': 'Tillbaka',
  'pay.noEmployers': 'Inga arbetsgivare',
  'pay.home': 'Hem',
  'pay.homeHelp': 'Din anställdsida hos den valda arbetsgivaren — lönebesked, utlägg och resor.',
  'pay.myPage': 'Min sida',
  'pay.myPageHelp': 'Ditt personliga konto i Plumme — profil, företag och privatekonomi.',
  'pay.signOut': 'Logga ut',
  'pay.paidByCompanyHint': 'Verifikationen skickas till bokföringen, inte till ersättning.',
  'pay.paidPrivateHint': 'Du får beloppet ersatt med lönen.',
  'pay.expenseProject': 'Projekt',
  'pay.expenseProjectHint': 'Utlägg på ett projekt kan vidarefaktureras till kunden.',
  'pay.expenseNoProject': 'Inte på projekt',
  'pay.myHours': 'Mina timmar',
  'pay.hoursThisMonth': '{time} den här månaden',
  'pay.hoursHelp': 'Timmarna du har registrerat på projekt för den här arbetsgivaren.',
  'pay.registerHours': 'Registrera timmar',
  'pay.timeNew': 'Registrera timmar',
  'pay.timeEdit': 'Ändra tid',
  'pay.timeDate': 'Datum',
  'pay.timeProject': 'Projekt',
  'pay.timeActivity': 'Aktivitet',
  'pay.timeHours': 'Timmar',
  'pay.timeNote': 'Anteckning',
  'pay.timeNotePh': 'Vad arbetade du med?',
  'pay.timePickProject': 'Välj projekt …',
  'pay.timePickActivity': 'Välj aktivitet …',
  'pay.timeSum': 'Summa',
  'pay.timeSaved': 'Tiden har sparats',
  'pay.timeDeleted': 'Tiden har tagits bort',
  'pay.timeFailed': 'Kunde inte spara tiden.',
  'pay.timeLocked': 'Tidrapporteringen för den här perioden är markerad som klar.',
  'pay.timeLockedThrough': 'Tidrapporteringen är markerad som klar till och med {date}.',
  'pay.timeEmptyTitle': 'Inga timmar den här veckan',
  'pay.timeEmpty': 'Tryck på ”Registrera timmar” för att lägga in den första.',
  'pay.timeNoProjectsTitle': 'Inga projekt',
  'pay.timeNoProjects': 'Din arbetsgivare har inte skapat några projekt som du kan registrera timmar på än.',
  'pay.timePrevWeek': 'Föregående vecka',
  'pay.timeNextWeek': 'Nästa vecka',
  'pay.myEmployeePage': 'Min anställdsida',
  'pay.myEmployeePageHelp': 'Din sida som anställd hos en arbetsgivare — skild från eventuell bokföring du sköter. Här ser du dina lönebesked och registrerar utlägg och resor som du ska få ersättning för. Högst upp byter du mellan arbetsgivare du är anställd hos.',
  'pay.employer': 'Arbetsgivare',
  'pay.employerHelp': 'Arbetsgivaren som den här sidan gäller. Är du anställd på flera ställen byter du här — då visar lönebesked, utlägg och resor siffrorna för den valda arbetsgivaren.',
  'pay.payslipsHelp': 'Lönebeskeden från arbetsgivaren — en översikt över lön, skatteavdrag och utbetalt belopp för varje lönekörning. Tryck för att öppna.',
  'pay.expensesHelp': 'Utlägg du har betalat ur egen ficka och ska få tillbaka — t.ex. ett kvitto på något du köpt privat. Skicka in dem för godkännande, så ersätts de via lönen.',
  'pay.travelHelp': 'Reseräkningar med milersättning, traktamente och utlägg kopplade till en resa. Skicka in dem för godkännande och ersättning via lönen.',
  'pay.registerExpenseHelp': 'Registrera ett nytt utlägg du har betalat — ladda upp kvittot, ange belopp och vad det gäller. Skickas till arbetsgivaren för godkännande och ersättning.',
  'pay.registerTravelHelp': 'Registrera en reseräkning — körningar (milersättning), traktamente och utlägg kopplade till resan. Skickas till arbetsgivaren för godkännande.',
  'pay.employmentStatusLabel.active': 'Aktiv anställning',
  'pay.employmentStatusLabel.ended': 'Slutat',
  'pay.employmentStatusLabel.future': 'Börjar senare',
  'pay.taxRuleNotSupported': 'stöds inte än',
  'pay.taxRuleNotSupportedHint': 'Plumme beräknar bara ordinarie skatt och arbetsgivaravgift. En lönekörning med den här anställda kan inte godkännas – kör lönen för den anställda utanför Plumme.',
  'pay.portalEmploymentEnded': 'Din anställning har avslutats. Du kan fortfarande se dina lönebesked, men inte skicka in nya utlägg, resor eller timmar. Kontakta arbetsgivaren om du har ett utlägg som ska ersättas.',
  'err.employeePortal.employmentEnded': 'Anställningen har avslutats och personalportalen är nu endast för läsning. Be arbetsgivaren registrera utlägget.',
  'pay.foreignAmount.label': 'Belopp betalt i NOK',
  'pay.foreignAmount.hint': 'Kvittot är i {currency}. Ange vad du faktiskt betalade i norska kronor, till exempel från kontoutdraget. Utlägget kan inte godkännas utan NOK-belopp.',
  'pay.foreignAmount.rateHint': 'Motsvarar kursen {rate} NOK per {currency}.',
  'pay.foreignAmount.missing': 'NOK-belopp saknas',
  'pay.foreignAmount.missingOnApproval': 'Utlägget ”{description}” är i {currency} och saknar NOK-belopp. Redigera raden och lägg in beloppet som faktiskt betalades i NOK innan du godkänner.',
  'err.payroll.foreignAmountMissingNok': 'Ett utlägg i utländsk valuta saknar NOK-belopp. Lägg in beloppet som faktiskt betalades i NOK innan du godkänner.',
  'pay.tabSalaryTax': 'Lön & skatt',
  'pay.tabPayslipsExpenses': 'Lönebesked & utlägg',
  'pay.taxRuleOption.ordinary': 'Ordinarie',
  'pay.taxRuleOption.svalbard': 'Svalbard',
  'pay.taxRuleOption.janMayen': 'Jan Mayen och biländerna',
  'pay.taxRuleOption.seafarerDeduction': 'Särskilt avdrag för sjöfolk',
  'pay.taxRuleOption.charity': 'Välgörande eller allmännyttig organisation',
  'pay.taxRuleOption.netPay': 'Nettolön',
  'pay.taxRuleOption.netPaySeafarer': 'Nettolön för sjöfolk',
  'pay.taxRuleOption.pensionSourceTax': 'Källskatt på pensioner',
  'pay.taxRuleOption.nanny': 'Dagmamma i barnets hem',
  'pay.taxRuleOption.homeWork': 'Lönearbete i hemmet',
  'pay.taxRuleOption.taxFreeOrg': 'Skattefri organisation',
  'pay.employmentTypeOption.ordinary': 'Ordinarie anställning',
  'pay.employmentTypeOption.maritime': 'Maritim anställning',
  'pay.employmentTypeOption.freelance': 'Frilansare, uppdragstagare eller arvodesmottagare',
  'pay.employmentTypeOption.pension': 'Pension eller annat avdragspliktigt förhållande',
  'pay.employmentTypeOption.notEmployed': 'Inte anställd',
  'pay.employmentTypeOption.simplifiedPrivate': 'Förenklad redovisningsordning, privat arbetsgivare',
  'pay.employmentTypeOption.simplifiedCharity': 'Förenklad redovisningsordning, välgörande organisation',
  'pay.employmentTypeOption.foreignService': 'Utländskt tjänsteförhållande',
  'pay.employmentTypeOption.boardFee': 'Styrelsearvode',
  'pay.employmentFormOption.permanent': 'Tillsvidare',
  'pay.employmentFormOption.temporary': 'Tidsbegränsad',
  'pay.employmentFormOption.temporarySubstitute': 'Tidsbegränsat anställd som timvikarie',
  'pay.employmentFormOption.permanentHiredOut': 'Tillsvidareanställning och uthyrd',
  'pay.employmentFormOption.temporaryHiredOut': 'Tidsbegränsad anställning och uthyrd',
  'pay.shift.offshore': 'Offshore',
  'pay.hourlyOvertimePay': 'Timlön - övertid',
  'pay.fixedLine': 'Fast rad',
  'pay.portalAccess.notInvited': 'Ingen åtkomst given',
  'pay.portalAccess.active': 'Aktiv åtkomst',
  'pay.portalAccess.revoked': 'Åtkomst återkallad',
  'pay.documentUploaded': 'Dokumentet har laddats upp.',
  'pay.documentsUploaded': 'Dokumenten har laddats upp.',
  'pay.documentDeleted': 'Dokumentet har tagits bort.',
  'pay.amountRequired': 'Ange ett belopp.',
  'pay.fixedLineDeleted': 'Fast lönerad borttagen.',
  'pay.fixedLineDeleteFailed': 'Kunde inte ta bort fast lönerad.',
  'pay.emailRequiredFirst': 'Lägg in en giltig e-postadress på den anställdas profil först.',
  'pay.portalAccessSent': 'Åtkomst skickad till {email}.',
  'pay.portalAccessRevokedToast': 'Åtkomsten har återkallats.',
  'pay.portalAccessSendFailed': 'Kunde inte skicka åtkomst.',
  'pay.portalAccessRevokeFailed': 'Kunde inte återkalla åtkomst.',
  'pay.saveEmployeeFailed': 'Kunde inte spara den anställda.',
  'pay.confirmDeleteDocument': 'Ta bort dokumentet "{name}"?',
  'pay.confirmDeleteFixedLine': 'Ta bort fast lönerad "{line}" för {name}?',
  'pay.confirmRevokePortalAccess': 'Återkalla åtkomst till personalportalen för {name}?',
  'pay.taxCardValidUntil': 'Skattekort giltigt till',
  'pay.leaveOfAbsence': 'Ledigheter',
  'pay.noLeaveRegistered': 'Ingen registrerad',
  'pay.loginEmail': 'E-post för inloggning',
  'pay.lastSent': 'Senast skickad',
  'pay.revoked': 'Återkallad',
  'pay.bankAccount': 'Bankkonto',
  'pay.hoursInFullWeek': 'Timmar i en hel vecka',
  'pay.uploading': 'Laddar upp ...',
  'pay.newDocument': 'Nytt dokument',
  'pay.resendAccess': 'Skicka åtkomst igen',
  'pay.grantEmployeeAccess': 'Ge anställd åtkomst',
  'pay.revoking': 'Återkallar ...',
  'pay.revokeAccess': 'Återkalla åtkomst',
  'pay.portalAccessExplain': 'Åtkomsten kopplas till den anställdas e-post och anställnings-ID. Själva anställdvyn använder den här kopplingen när portalinloggningen ansluts.',
  'pay.useStandardHolidayRate': 'Använd standardsatsen från löneinställningarna ({rate} %)',
  'pay.priorYearSalaryHeading': 'Lön {year}',
  'pay.payrollDataHidden': 'Lönedata är dolda för denna åtkomst',
  'pay.payrollDataHiddenBody': 'Anställda, fasta lönerader och löneutbetalningar ligger i ett separat personaldokument. Din roll för denna klient är {role}, och appen fick inte läsa personaldokumentet. Resor och utlägg som är bokförda i bokföringen kan därför fortfarande visas.',
  'pay.unknownAccess': 'okänd åtkomst',
  'pay.readAccess': 'Läsåtkomst',
  'pay.registerFirstEmployee': 'Registrera den första anställda för att använda lönekörning, skattekort och a-melding.',
  'pay.mainEmployerOption': 'Huvudarbetsgivare',
  'pay.secondaryEmployerOption': 'Bisyssla',
  'pay.documentsCount': '{count} dokument',
  'pay.noDocumentsUploaded': 'Inga uppladdade dokument',
  'pay.cannotOpenDocument': 'Det gick inte att öppna dokumentet.',
  'pay.cannotDownloadDocument': 'Det gick inte att ladda ner dokumentet.',
  'pay.endEmployment': 'Avsluta anställning',
  'pay.reopenEmployment': 'Återöppna anställning',
  'pay.earnedHolidayPayInYear': 'Intjänad semesterersättning {year}',
  'pay.holidayPayNotPaidBeforeStartHint': 'Semesterersättning som inte har betalats ut före startdatumet i Plumme.',
  'pay.earnedTaxablePayInYear': 'Intjänad lön (skatteunderlag) {year}',
  'pay.grossPayNotInPlummeHint': 'Bruttolön som betalats ut från företaget {year} och som inte är bokförd i Plumme.',
  'pay.withheldTaxInYear': 'Innehållen skatt {year}',
  'pay.priorYearAmountWarning': 'Belopp för {year} ska bara fyllas i om de inte ingår i andra löneutbetalningar som är bokförda i Plumme.',
  'pay.agreedSalaryInternalNote': 'Avtalad lön används bara som intern dokumentation. Lönekörningen styrs av fasta eller manuella lönerader.',
  'pay.estimatedAnnualSalaryFrom': 'Uppskattad årslön beräknas utifrån {summary}',
  'pay.fixedLinesRegisteredCount': '{count} registrerade',
  'pay.fixedLinesOnEmployee': 'Fasta lönerader som ligger på denna anställda.',
  'pay.noFixedLinesRegistered': 'Inga fasta rader har registrerats.',
  'pay.internalDocumentationNote': 'Detta är intern dokumentation. Lönekörningen använder fasta lönerader eller manuella rader på löneutbetalningen.',
  'pay.noAgreedSalaryBody': 'Lägg in årslön eller timlön för att se uppskattad årskostnad, semesterersättning, arbetsgivaravgift och skatt.',
  'pay.selectOccupationCode': 'Välj yrkeskod ...',
  'pay.noOccupationCodeMatch': 'Inga träffar på "{query}".',
  'pay.editEmployeeTitle': 'Redigera anställd',
  'pay.newEmployeeTitle': 'Ny anställd',
  'err.nativeValidation.payrollManualAMelding.1': 'Manuell registrering av a-melding kräver norsk lönekörning.',
  'err.nativeValidation.payrollManualAMelding.2': 'Manuell inlämning måste bekräftas uttryckligen.',
  'err.nativeValidation.payrollManualAMelding.3': 'Giltig rapporteringsperiod, inlämningsdatum och manuell referens måste anges.',
  'err.nativeValidation.payrollManualAMelding.4': 'Inlämningsdatumet måste vara efter rapporteringsmånaden och kan inte ligga i framtiden.',
  'err.nativeValidation.payrollManualAMelding.5': 'Bekräfta exakt de bokförda lönekörningarna i rapporteringsmånaden.',
  'err.nativeValidation.payrollManualAMelding.6': 'Den manuella rapportreferensen är redan registrerad för denna månad.',
  'err.nativeValidation.pensionPremiumMutation.1': 'Pensionsbetalning kräver norsk bokföring i NOK.',
  'err.nativeValidation.pensionPremiumMutation.2': 'Giltig pensionsverifikation och datum måste anges.',
  'err.nativeValidation.pensionPremiumMutation.3': 'Denna pensionsbetalning stöder bara de kontrollerade satserna för 2026 i zon I.',
  'err.nativeValidation.pensionPremiumMutation.4': 'Pensionsbetalning använder NOK-bankkonto 1920.',
  'err.nativeValidation.pensionPremiumMutation.5': 'Pensionsbelopp måste vara ändliga, icke-negativa tal med hela öre.',
  'err.nativeValidation.pensionPremiumMutation.6': 'Pensionsbetalningen kan inte registreras före bokföringsdatumet.',
  'err.nativeValidation.pensionPremiumMutation.7': 'Verifikationsidentiteten för pensionen är redan reserverad.',
  'err.nativeValidation.pensionPremiumMutation.8': 'Numreringshistoriken för pension är ogiltig.',
});
